import React, {useCallback, useEffect, useState} from 'react'
import {HiMenuAlt4, HiX} from 'react-icons/hi'
import {motion} from 'framer-motion'

import {images, navItem} from '../../constants'
import './Navbar.scss'

const Navbar = () => {

    // hamburger menu
    const [toggle, setToggle] = useState(false)
    const [retracted, setRetracted] = useState("");
    const handleScroll = useCallback(() => {
        const currentPosScroll = window.scrollY;
        setRetracted(currentPosScroll > 200 ? 'retracted' : '');
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [retracted, handleScroll]);


    return (
        <nav className={'app__navbar ' + retracted} >
            <div className='app__navbar-logo'>
                <img src={images.logo} alt='logo' />
            </div>
            <ul className='app__navbar-links'>
                {navItem.map((item) => (
                    <li className='app__flex p-text' key={`link-${item}`}>
                        <div/> {/*for dot above item*/}
                        <a href={`#${item}`}>{item}</a>
                    </li>
                ))}
            </ul>
            <ul className="app__navbar-login">
                <li className="app_flex p-text">
                    <a href="/">Login</a>
                </li>
                <li className="app_flex p-text">
                    <a href="/">Logout</a>
                </li>
            </ul>

            <div className='app__navbar-menu'>
                <HiMenuAlt4 onClick={() => setToggle(true)}/>
                {toggle && (
                    <motion.div
                        whileInView={{x: [300, 0]}}
                        transition={{duration: 0.85, ease: 'easeOut'}}
                    >
                        <HiX onClick={() => setToggle(false)}/>
                        <ul>
                            {navItem.map((item) => (
                                <li key={item}>
                                    <a href={`#${item}`} onClick={() => setToggle(false)}>{item}</a>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                )}
            </div>

        </nav>
    )
}

export default Navbar